export default {
	computed: {
		getReadytoShop() {
			return this.$store.getters.getReadytoShop;
		},

		wishlistData() {
			return this.$store.getters['sso/getWishlist'];
		},

		rawShopProducts() {
			return this.$store.getters['shopapi/getRawProducts'];
		},

		shopProducts() {
			return this.$store.getters['shopapi/getProducts'];
		},

		validWishlistProducts() {
			// Filters the wishlist by products that exist in the shopProducts and that are in stock.
			const validProducts = {};
			if (this.wishlistData && this.rawShopProducts) {
				Object.keys(this.wishlistData.wishlist.products).forEach(productId => {
					// Find the "raw product" to get it's type...
					const rawProd = this.rawShopProducts.find(prod => prod.id === productId);
					if (rawProd) {
						// ... and use that product type to check if it exists in the type-sorted shopProducts.

						let shopProductData = undefined;

						for (const category of Object.values(this.shopProducts)) {
							shopProductData = category.find(shopProd => shopProd.id === productId);
							if (shopProductData) break;
						}

						if (shopProductData && !shopProductData.soldOut && shopProductData.stockAvailable >= 1) {
							validProducts[productId] = this.wishlistData.wishlist.products[productId];
						}
					}
				});
			}
			return validProducts;
		},

		isMemberSaleUsed() {
			return this.$store.getters['sso/getIsMemberSaleUsed'];
		}
	},

	watch: {
		getReadytoShop(val) {
			if (val) {
				if (this.data.membersale || this.data.preregistration || this.data.travelsale) {
					if (this.data.preregistration && this.userHasPreregistered && this.wishlistData) {
						/*
						 * Update the users whislist
						 */
						this.fillCartInPreregistrationMode();
						return;
					}

					if (this.userHasPreregistered && this.wishlistData && !this.isMemberSaleUsed) {
						/*
						 * Fill the cart with the valid whishlist products
						 */

						const { wishlist } = this.wishlistData;
						const showWishlist =
							wishlist && wishlist.products && Object.entries(wishlist.products).length !== 0;

						showWishlist && this.$store.commit('setModalPrefillCartActive', true);
						return;
					}
				}

				if (this.wishlistData) {
					const { wishlist } = this.wishlistData;
					const showWishlist =
						wishlist && wishlist.products && Object.entries(wishlist.products).length !== 0;

					showWishlist && this.$store.commit('setModalPrefillCartActive', true);
				}
			}
		}
	},

	methods: {
		/*
		 * Update the users fake cart with the whislistData.
		 */
		async fillCartInPreregistrationMode() {
			const { wishlist, travelCart } = this.wishlistData;

			if (!wishlist || !wishlist.products) {
				return;
			}

			await this.$store.dispatch('travelapi/loadSettings');
			await this.$store.dispatch('travelapi/loadFilters');
			await this.$store.dispatch('travelapi/loadPackages');
			this.$store.commit('shopconfig/setTravelCart', travelCart);

			Object.keys(this.validWishlistProducts).forEach(key => {
				const payload = {
					params: {
						productId: key,
						quantity: this.validWishlistProducts[key]
					},
					/*
					 * ugly but needed to add hotel
					 */
					url: wishlist.hotel ? '/hotel/' : '',
					/*
					 * prevent updateing profile preferences when importing
					 * otherwise thise will cause prodcuts to be overwritten and there for left out
					 */
					dontUpdateWishlist: true
				};

				this.$store.dispatch('shopapi/fillpreregisterCart', payload);
			});
		},

		/*
		 * Update the real cart with the whislistData.
		 */
		fillCartInSaleMode() {}

		/*
		 * Update the user preferences with the whislistData.
		 * If user is for ex. inqonito modus the previeusly set cookie wil nog be found.
		 * We now the set cookie with the data we know from the profile preferences
		 */
		/* updateCookieWithWishList() {
			if (this.data.membersale || this.data.preregistration || this.data.travelsale) {
				if (this.userHasPreregistered && this.wishlistData) {
					const cookieData = [...this.wishlistData.saleType];

					if (!this.shopConfig.preregistration && !this.shopConfig.travelsale) {
						cookieData.push({
							key: 'ticket',
							value: 'ticket'
						});
					}

					this.$cookies.remove(`q_eb_${this.shopConfig.slug}`);
					this.$cookies.set(`q_eb_${this.shopConfig.slug}`, cookieData, {
						path: '/',
						maxAge: 6 * 30 * 24 * 3600 // 6 months
					});

					this.$store.commit('shopconfig/setUserexperience', cookieData);
				}
			}
		} */
	}
};
